import React from 'react'

import { useCorporateSignOut } from '@/hooks/useCorporateSignOut'
import { DarkModeMenu } from '../signup/DarkmodeSignUpPanel'

export const CorporatePageLayout = React.memo(function CorporatePageLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const signOut = useCorporateSignOut()

  return (
    <div
      data-testid="container-corporate-signup-container"
      className="relative p-5 md:pt-20 md:pb-0 w-full max-w-3xl mx-auto"
    >
      {window.self === window.top && (
        <div
          data-testid="container-corporate-signup-darkmode"
          className="absolute top-4 right-0 md:top-10 md:right-0"
        >
          <DarkModeMenu showSignOutButton onSignOut={signOut} />
        </div>
      )}
      <div
        data-testid="container-corporate-signup-content"
        className="flex-grow"
      >
        {children}
      </div>
    </div>
  )
})
